import { Injectable } from '@angular/core';
import { RemoteConfigService } from './remote-config.service';
import { NativeRemoteConfigService } from './native-remote-config.service';
import { WebRemoteConfigService } from './web-remote-config.service';
import { PlatformServiceInitializerBase, PlatformServiceConfig } from '../platform-service-initializer.base';

@Injectable({ providedIn: 'root' })
export class RemoteConfigInitializer extends PlatformServiceInitializerBase<
  RemoteConfigService,
  NativeRemoteConfigService,
  WebRemoteConfigService
> {
  protected override config: PlatformServiceConfig<
    RemoteConfigService,
    NativeRemoteConfigService,
    WebRemoteConfigService
  > = {
    serviceName: 'RemoteConfig',
    nativeServicePath: '@core/firebase/native-remote-config.service',
    webServicePath: '@core/firebase/web-remote-config.service',
    nativeServiceType: NativeRemoteConfigService,
    webServiceType: WebRemoteConfigService,
  };

  get remoteConfigService(): RemoteConfigService {
    return this.serviceInstance;
  }
}
